import React, { useContext } from 'react';
import ServiceBlock from './ServiceBlock/ServiceBlock';
import classes from './OurServices.module.css';
import frontPinkForDark from './frontendPink.png';
import frontPinkForLight from './frontendBlue.png';
import databasePinkForDark from './databasePink.png';
import databasePinkForLight from './databaseBlue.png';
import optimizationPinkForDark from './optimizationPink.png';
import optimizationPinkForLight from './optimizationBlue.png';
import safetyPinkForDark from './safetyPink.png';
import safetyPinkForLight from './safetyBlue.png';
import responsibilityPinkForDark from './responsibilityPink.png';
import responsibilityPinkForLight from './responsibilityBlue.png';
import connectionPinkForDark from './connectionPink.png';
import connectionPinkForLight from './connectionBlue.png';
import { ThemeContext } from '../../App';

export default function OurServices() {
  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.ourServicesContainer}>
      <h3 className="text-smBtwPages md:text-mdBtwPages lg:text-lgBtwPages text-center">
        Our services
      </h3>
      <div
        className={
          classes.blocksContainer + ' flex flex-row flex-wrap lg:flex-nowrap'
        }
      >
        <ServiceBlock
          image={theme === 'dark' ? frontPinkForDark : frontPinkForLight}
          text="User interface development"
        />
        <ServiceBlock
          image={
            theme === 'dark'
              ? optimizationPinkForDark
              : optimizationPinkForLight
          }
          text="Performance optimization"
        />
        <ServiceBlock
          image={
            theme === 'dark'
              ? responsibilityPinkForDark
              : responsibilityPinkForLight
          }
          text="Adaptive design"
        />
        <ServiceBlock
          image={theme === 'dark' ? databasePinkForDark : databasePinkForLight}
          text="Development of the application backend"
        />
        <ServiceBlock
          image={
            theme === 'dark' ? connectionPinkForDark : connectionPinkForLight
          }
          text="Integration with external systems"
        />
        <ServiceBlock
          image={theme === 'dark' ? safetyPinkForDark : safetyPinkForLight}
          text="Ensuring security"
        />
      </div>
    </div>
  );
}
